export default __webpack_public_path__ + "static/media/placeholder_dummy2016-tattoo01-mobile-de.5e9172aa.png";